'use es6';

export const CUSTOM_WIDGET_FIELD_TABLE_ROW = 'CUSTOM_WIDGET_FIELD_TABLE_ROW';
export const CUSTOM_WIDGET_CHOICE_FIELD_OPTION = 'CUSTOM_WIDGET_CHOICE_FIELD_OPTION';
export const FINDER_FILE = 'FINDER_FILE';
export const FINDER_FOLDER = 'FINDER_FOLDER';
export const LAYOUT_ROW = 'LAYOUT_ROW';
export const LAYOUT_CELL = 'LAYOUT_CELL';
export const LAYOUT_VIRTUAL_CELL = 'LAYOUT_VIRTUAL_CELL';
export const LAYOUT_WIDGET = 'LAYOUT_WIDGET';
export const LAYOUT_FLEX_COLUMN = 'LAYOUT_FLEX_COLUMN';
export const LAYOUT_CUSTOM_WIDGET = 'LAYOUT_CUSTOM_WIDGET';
export const LAYOUT_GLOBAL_GROUP = 'LAYOUT_GLOBAL_GROUP';
export const LAYOUT_GLOBAL_WIDGET = 'LAYOUT_GLOBAL_WIDGET';
export const LAYOUT_SECTION_DELIMITER = 'LAYOUT_SECTION_DELIMITER';
export const LAYOUT_SECTION_DELIMITER_ROW = 'LAYOUT_SECTION_DELIMITER_ROW';
export const LAYOUT_HORIZONTAL_RESIZE_HANDLE = 'LAYOUT_HORIZONTAL_RESIZE_HANDLE';
export const WIDGET_SIDEBAR_WIDGET = 'WIDGET_SIDEBAR_WIDGET';
export const WIDGET_SIDEBAR_CELL = 'WIDGET_SIDEBAR_CELL';
export const WIDGET_SIDEBAR_VIRTUAL_CELL = 'WIDGET_SIDEBAR_VIRTUAL_CELL';
export const WIDGET_SIDEBAR_FLEX_COLUMN = 'WIDGET_SIDEBAR_FLEX_COLUMN';
export const WIDGET_SIDEBAR_CUSTOM_WIDGET = 'WIDGET_SIDEBAR_CUSTOM_WIDGET';
export const WIDGET_SIDEBAR_GLOBAL_GROUP = 'WIDGET_SIDEBAR_GLOBAL_GROUP';
export const WIDGET_SIDEBAR_GLOBAL_WIDGET = 'WIDGET_SIDEBAR_GLOBAL_WIDGET';
export const SORTABLE_LIST_ITEM = 'SORTABLE_LIST_ITEM';
export const TAB = 'TAB';